import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { ConciergeSenderPanel } from "../../components/concierge/Concierge";

export default function ConciergeHome() {
  return (
    <div className="max-w-[1100px] mx-auto p-6" data-testid="sender-concierge-page">
      <Link to="/sender" className="text-sm underline inline-flex items-center gap-1 mb-4" data-testid="concierge-back-to-shipments">
        <ArrowLeft size={14} weight="bold" /> My Shipments
      </Link>
      <ConciergeSenderPanel />
    </div>
  );
}
